module.exports = __webpack_public_path__ + "static/media/scheda-iscrizione-scarico-responsabilita-2024.bab06b36.pdf";